import { render, staticRenderFns } from "./free-transaction-banner.vue?vue&type=template&id=1fd08d3b"
import script from "./free-transaction-banner.vue?vue&type=script&lang=js"
export * from "./free-transaction-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports